import React from 'react';

const Icon = ({ size = '40', fill = 'black', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...other}>
            <path
                d="M5 20c0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15Zm10.782-7.55a1.25 1.25 0 0 0 0 1.767l5.783 5.782-5.783 5.783-.086.095a1.251 1.251 0 0 0 1.76 1.759l.094-.086 6.667-6.666a1.25 1.25 0 0 0 0-1.768L17.55 12.45a1.25 1.25 0 0 0-1.768 0Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
